import React from 'react'

export default function StudentLogsTable({
  records = [],
  loading = false,
}) {
  const getModuleBadge = (mod = '') => {
    const lower = mod.toLowerCase()
    if (lower.includes('login')) {
      return 'bg-emerald-500/10 text-emerald-800 border-emerald-500/30'
    }
    if (lower.includes('logout')) {
      return 'bg-rose-500/10 text-rose-800 border-rose-500/30'
    }
    if (lower.includes('fee')) {
      return 'bg-amber-500/10 text-amber-800 border-amber-500/30'
    }
    if (lower.includes('test') || lower.includes('performance')) {
      return 'bg-purple-500/10 text-purple-800 border-purple-500/30'
    }
    if (lower.includes('lecture') || lower.includes('syllabus')) {
      return 'bg-indigo-500/10 text-indigo-800 border-indigo-500/30'
    }
    if (lower.includes('feedback')) {
      return 'bg-cyan-500/10 text-cyan-800 border-cyan-500/30'
    }
    return 'bg-blue-500/10 text-blue-800 border-blue-500/30'
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] text-left text-xs text-on-surface">
          {/* ── Table Header ── */}
          <thead className="border-b border-outline-variant/25 bg-surface-container-low/80 text-[11px] font-black uppercase tracking-[0.1em] text-on-surface-variant select-none">
            <tr>
              <th className="w-64 px-4 py-3.5">
                <span>Name</span>
              </th>
              <th className="w-48 px-4 py-3.5">
                <span>Date &amp; Time</span>
              </th>
              <th className="w-40 px-4 py-3.5">
                <span>Modules</span>
              </th>
              <th className="px-4 py-3.5">
                <span>Remarks</span>
              </th>
            </tr>
          </thead>

          {/* ── Table Body ── */}
          <tbody className="divide-y divide-outline-variant/15 font-medium">
            {loading ? (
              <tr>
                <td colSpan={4} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined animate-spin text-2xl text-primary">
                      progress_activity
                    </span>
                    <span>Loading student activity logs...</span>
                  </div>
                </td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={4} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined text-4xl text-outline-variant">
                      manage_search
                    </span>
                    <p className="font-bold text-on-surface">No Activity Logs Found</p>
                    <p className="text-[11px]">No student records match the selected module &amp; date filters.</p>
                  </div>
                </td>
              </tr>
            ) : (
              records.map((item) => (
                <tr
                  key={item.id}
                  className="group transition-colors hover:bg-surface-container-low/50"
                >
                  {/* Student Name */}
                  <td className="px-4 py-4 align-top">
                    <div className="flex items-center gap-2.5">
                      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-primary/10 text-primary font-bold text-xs shrink-0">
                        {item.name.charAt(0)}
                      </div>
                      <span className="font-bold text-on-surface">
                        {item.name}
                      </span>
                    </div>
                  </td>

                  {/* Date & Time */}
                  <td className="px-4 py-4 align-top">
                    <span className="text-xs text-on-surface-variant flex items-center gap-1 font-mono">
                      <span className="material-symbols-outlined text-xs text-primary">schedule</span>
                      <span>{item.date}</span>
                    </span>
                  </td>

                  {/* Module Badge */}
                  <td className="px-4 py-4 align-top">
                    <span
                      className={`inline-flex items-center rounded-xl border px-2.5 py-0.5 text-[10px] font-black uppercase tracking-wider ${getModuleBadge(
                        item.module
                      )}`}
                    >
                      {item.module}
                    </span>
                  </td>

                  {/* Remarks */}
                  <td className="px-4 py-4 align-top">
                    <p className="text-xs text-on-surface font-medium leading-relaxed">
                      {item.remarks}
                    </p>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
